<div class="w-full p-gutter text-center">
    
    <img class="w-full max-w-lg mx-auto mb-6" src="assets/img/illustrations/data_center.svg" alt="Página no encontrada">
  
    <h1 class="display-3 font-medium m-0">404</h1>
    <h2 class="headline m-0">Página no encontrada.</h2>

  </div>